import React from 'react';
import PropTypes from 'prop-types';

/**
 * Catches a render error in the storefront's pages. Without it one error
 * unmounts the whole app and a customer sees a blank white page (this is what
 * happened when the header crashed on an empty cart) — with it, they see a
 * short message and a way to reload.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Storefront error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-[12px] px-[16px] text-center">
        <h1 className="text-[20px] font-semibold text-gray-800">Something went wrong</h1>
        <p className="text-[14px] text-gray-600">Please reload the page to keep shopping.</p>
        <button
          type="button"
          className="rounded-[8px] border border-gray-300 bg-white px-[16px] py-[8px] text-[14px] font-medium text-gray-800"
          onClick={() => window.location.reload()}
        >
          Reload page
        </button>
      </div>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
